import { useQuery } from 'react-query';
import { APIGetWarehouseMasters, IWarehouseMaster } from '../../service/api/APIWarehouseMaster';

export const useGetWarehouseMasters = () => {
  return useQuery<IWarehouseMaster[], Error>(
    ['getWarehouseMasters'],
    APIGetWarehouseMasters,
    {
      staleTime: 30 * 60 * 1000, // 30 minutes
      cacheTime: 60 * 60 * 1000, // 1 hour
      refetchOnWindowFocus: false,
    }
  );
};
